package com.yogaaicoach.user

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import com.yogaaicoach.common.network.ApiClient
import com.yogaaicoach.common.network.TokenResponse
import com.yogaaicoach.pages.auth.TokenDataManager
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

/**
 * AppViewModel to keep high level states of the app, It's currently also kind of UserViewModel
 * TODO refactor them to separate from each other
 */
class AppViewModel(private val apiClient: ApiClient) : ViewModel() {
    private val _isLoading = MutableStateFlow(true)
    val isLoading: StateFlow<Boolean> = _isLoading

    private val _isLoggedIn = MutableStateFlow(false)
    val isLoggedIn: StateFlow<Boolean> = _isLoggedIn

    private val _userInfo = MutableStateFlow<UserInfo?>(null)
    val userInfo: StateFlow<UserInfo?> = _userInfo

    // it's more over config than user related, but since we need to keep this state, let it be here
    var isPortrait by mutableStateOf(false)
        private set

    var isPortraitInitialized by mutableStateOf(false)
        private set


    private val _pageTitleRes = MutableStateFlow<String?>(null)
    val pageTitleRes: StateFlow<String?> = _pageTitleRes

    private val _askBackNavConfirm = MutableStateFlow(false)
    val askBackNavConfirm: StateFlow<Boolean> = _askBackNavConfirm

    var onBackButton: (() -> Unit)? by mutableStateOf(null)
        private set

    init {
        viewModelScope.launch {
            _userInfo.value = getUserInfo()

            if (userInfo.value == null) {
                _isLoggedIn.value = false
            } else if (isTokenActive(userInfo.value!!.tokenData.expirationTimestampMs)) {
                _isLoggedIn.value = true
            } else { // Try ask new token
                askNewToken()
            }
            _isLoading.value = false
        }
    }

    fun setOnBackButtonAction(onBackButton: (() -> Unit)) {
        this.onBackButton = onBackButton
    }

    fun handleUserLoginSuccess(userInfo: UserInfo) {
        _isLoggedIn.value = true
        _userInfo.value = userInfo
    }

    fun signOut() {
        clearUserInfo()
        TokenDataManager.clear()
        _userInfo.value = null
        _isLoggedIn.value = false
    }

    @OptIn(ExperimentalTime::class)
    private fun isTokenActive(expirationTime: Long): Boolean {
        return expirationTime > Clock.System.now().toEpochMilliseconds()
    }

    suspend fun askNewToken() {
        val newToken = apiClient.getNewToken(TokenDataManager.tokenData!!.refreshToken)
        if (newToken == null) {
            signOut()
        } else {
            saveUserInfoInternal(newToken)
            _userInfo.value = getUserInfo()
            _isLoggedIn.value = true
        }
    }

    @OptIn(ExperimentalTime::class)
    private fun saveUserInfoInternal(newToken: TokenResponse) {
        val tokenData = TokenDataManager.initialize(
            accessToken = newToken.access_token,
            refreshToken = newToken.refresh_token,
            idToken = newToken.id_token,
            expirationTimestampMs = (newToken.expires_in.toLong() + Clock.System.now().epochSeconds) * 1000,
        )
        saveUserInfo(newToken.user_id, tokenData)
    }

    fun updateIsPortrait(newValue: Boolean) {
        isPortrait = newValue
        isPortraitInitialized = true
    }

    fun setPageTitle(newValue: String) {
        _pageTitleRes.value = newValue
    }

    fun resetPageTitle() {
        _pageTitleRes.value = null
    }

    fun updateAskBackNavConfirm(newValue: Boolean) {
        _askBackNavConfirm.value = newValue
    }
}
